import React, { useEffect, useState } from 'react';
import FirstStep from './FirstStep';
import CareerListingMinimal from 'views/CareerListingMinimal';
import Footer from 'layouts/Main/components/Footer';
import Container from 'components/Container';
import initialStepData from './initialStepData';
import secondStepData from 'views/CareerListingMinimal/secondStepData';
import thirdStepData from 'views/Startup/thirdStepData';
import Startup from 'views/Startup';
import Expo from 'views/Expo';
import StepFivePayment from './StepFivePayment';
import { WithNumbersOnly } from 'blocks/progressSteps';
import { Divider, Typography } from '@mui/material';
import Step6Success from './Step6Success';
import retrieveSavedApplicationService from './retrieveSavedApplicationService';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import DesignCompany from 'views/DesignCompany';

const NotFoundCover = () => {

  const window_ = globalThis.window;
  const searchParam = window_ && window_.location && window_.location.search;

  const urlSearchParams = new URLSearchParams(searchParam);
  const params = Object.fromEntries(urlSearchParams.entries());
  const [showLoader, setShowLoader] = useState(true);

  console.log('params', params);
  
  // const params1 = 
  useEffect(() => {
    if (params.applicationId && params.applicationId.trim()) {
      retrieveSavedApplicationService().then((res) => {
        console.log('data', res);
        const record = res.find((x) => x.id === parseInt(params.applicationId));
        const initData = {
          fullName: record.fullName,
          aadhar: record.aadhar,
          photo: record.photo,
          fileName: record.fileName || '',
          imagePreviewUrl: record.imagePreviewUrl || '',
          siblings: record.siblings,
          dateOfBirth: record.dateOfBirth,
          class: record.class1,
          birthPlace: record.birthPlace,
          nationality: record.nationality,
          religion: record.religion,
          motherTongue: record.motherTongue,
          gender: record.gender,
          sibling1Name: record.sibling1Name,
          sibling2Name: record.sibling2Name,
          sibling1Class: record.sibling1Class,
          sibling2Class: record.sibling2Class,
          sibling1Section: record.sibling1Section,
          sibling2Section: record.sibling2Section,
          physical: record.physical,
          stream: record.stream,
          option: record.option,
          transport: record.transport,
          application_id: params.applicationId,
        };
        const secondData = {
          fatherName: record.fatherName,
          motherName: record.motherName,
          phone: record.phone,
          phone1: record.phone1,
          email: record.email,
          email1: record.email1,
          fatherLang: record.fatherLang,
          motherLang: record.motherLang,
          resadd: record.resadd,
          resadd1: record.resadd1,
          area: record.area,
          area1: record.area1,
          dist: record.dist,
          dist1: record.dist1,
          state: record.state,
          state1: record.state1,
          country: record.country,
          country1: record.country1,
          pin: record.pin,
          pin1: record.pin1,
          offnum: record.offnum || '',
          offnum1: record.offnum1 || '',
          resnum: record.resnum,
          resnum1: record.resnum1,
          gross: record.gross,
          gross1: record.gross1,
          working: record.working,
          working1: record.working1,
          designation: record.designation,
          designation1: record.designation1,
          company: record.company,
          company1: record.company1,
          companyAdd: record.companyAdd,
          companyAdd1: record.companyAdd1,
          address: record.address,
          compPhoto: record.compPhoto,
          compPhoto1: record.compPhoto1,
          fileName: record.fileName,
          fileName1: record.fileName1,
          imagePreviewUrl: record.imagePreviewUrl,
          imagePreviewUrl1: record.imagePreviewUrl1,
          application_id: params.applicationId,
        };

        setInitialState(initData);
        setSecondState(secondData);
        setShowLoader(false);
      });
    } else {
      setShowLoader(false);
    }
  }, []);

  const [currentStep, setCurrentStep] = useState(1);
  const [initialState, setInitialState] = useState(initialStepData);
  const [secondState, setSecondState] = useState(secondStepData);
  const [thirdState, setThirdState] = useState(thirdStepData);

  const handleCurrentStep = (newStep, data) => {
    if (newStep === 2 && data) {
      setInitialState(data);
    }
    if (newStep === 3 && data) {
      setSecondState(data);
    }
    if (newStep === 4 && data) {
      setThirdState(data);
    }
    setCurrentStep(newStep);
  };

  if (showLoader) {
    return (
      <Box sx={{ display: 'flex' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <div style={{ height: 40, backgroundColor: '#377dff', padding: '10px' }}>
        <Typography
          style={{ float: 'left' }}
          variant={'subtitle2'}
          color={'white'}
        >
          NPS YPR
        </Typography>

        <a style={{ float: 'right', marginRight: 20 }} href="/online-registration-email-login">
          <img
            height={20}
            width={20}
            color={'white'}
            src="https://cdn-icons-png.flaticon.com/512/25/25376.png"
          />
        </a>
        <a style={{ float: 'right', marginRight: 20 }} href="/about">
          <img
            height={20}
            width={20}
            src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/34/Home-icon.svg/2048px-Home-icon.svg.png"
          />
        </a>
      </div>
      <div  style={{ display: 'flex' }}>
        <WithNumbersOnly currentStep={currentStep - 1} showProgressOnly />
      </div>
      <Container
        maxWidth={0.7}
        paddingTop={'0 !important'}
        bgcolor={'alternate.main'}
      >
        {currentStep === 1 && (
          <FirstStep
            handleCurrentStep={handleCurrentStep}
            initialState={initialState}
            sectionData={params.section && params.section.trim()}
            applicationNo={params.applicationId && params.applicationId.trim()}
          />
        )}
        {currentStep === 2 && (
          <CareerListingMinimal
            handleCurrentStep={handleCurrentStep}
            secondState={secondState}
            initialState={initialState}
          />
        )}
        {currentStep === 3 && (
          <DesignCompany
            handleCurrentStep={handleCurrentStep}
            thirdState={thirdState}
            secondState={secondState}
            initialState={initialState}
            sectionData={params.section && params.section.trim()}
          />
        )}
        {currentStep === 4 && (
          <Expo
            initialState={initialState}
            secondState={secondState}
            thirdState={thirdState}
            handleCurrentStep={handleCurrentStep}
          />
        )}
        {currentStep === 5 && (
          <StepFivePayment
            initialState={initialState}
            secondState={secondState}
            thirdState={thirdState}
            handleCurrentStep={handleCurrentStep}
          />
        )}
        {currentStep === 6 && (
          <Step6Success handleCurrentStep={handleCurrentStep} />
        )}
      </Container>
      <Container maxWidth={0.9}>
        <Footer />
      </Container>
    </>
  );
};

export default NotFoundCover;
